module.exports = __webpack_public_path__ + "img/a-ma_cultural_village.670f2f07.jpg";